import {Utils} from "../utils";
import {v4 as uuidv4} from 'uuid';

export class Message {
  constructor() {
    this.id = uuidv4();
    this.uuid = uuidv4();
    this.name = '';
    this.dependsOn = null;
    this.dependsOnOrder = null;
    this.beforeEvent = null;
    this.dependsOnUuid = null;
    this.description = '';
    this.subject = '';
    this.message = '';
    this.sendAt = null;
    this.status = null;
    this.delayCount = null;
    this.eventId = null;
    this.target = null;
    this.delayDirection = null;
    this.selectedTrigger = null;
    this.delayUnit = 'day';
    this.orderDate = null;
    this.date = null;
    this.time = null;
  }

  map(message) {
    this.id = message.id;
    this.name = message.name;
    this.description = message.description
    this.subject = message.subject;
    this.message = message.message;
    this.target = message.target;

    if (message.depends_on_event) {
        if (message.depends_on_event % 1440 == 0) {
            this.delayUnit = 'day';
            this.delayCount = message.depends_on_event / 1440;
        } else if (message.depends_on_event % 60 == 0) {
            this.delayUnit = 'hour';
            this.delayCount = message.depends_on_event / 60;
        } else if (message.depends_on_event % 1440 > 0 && message.depends_on_event % 60 > 0) {
            this.delayUnit = 'minute';
            this.delayCount = message.depends_on_event;
        } else {
            this.delayCount = null;
            this.delayUnit = null;
        }
    } else {
        this.delayCount = null;
        this.delayUnit = null;
    }

    this.delayDirection = message.before_event;

    this.selectedTrigger = message.event_id;

    this.dependsOn = message.depends_on;
    this.delay = message.delay;

    if (message.depends_on_event == null) {
        this.date = Utils.parseDate(new Date(message.send_at));
        this.time = Utils.parseTime(new Date(message.send_at));
    } else {
        this.date = null;
        this.time = null;
    }

    return this;
  }

  update(message) {
    if (message.id) this.id = message.id;
    if (message.uuid) this.uuid = message.uuid;
    if (message.name) this.name = message.name;
    if (message.description) this.description = message.description
    if (message.subject) this.subject = message.subject;
    if (message.message) this.message = message.message;
    if (message.delayCount) this.delayCount = message.delayCount;
    if (message.delayUnit) this.delayUnit = message.delayUnit;
    if (message.orderDate) this.orderDate = message.orderDate;
    if (message.sendAt) this.sendAt = message.sendAt;
    if (message.dependsOn) this.dependsOn = message.dependsOn;
    if (message.dependsOnOrder) this.dependsOnOrder = message.dependsOnOrder;
    if (message.eventId) this.eventId = message.eventId;
    if (message.target) this.target = message.target;
    if (message.delayDirection) this.delayDirection = message.delayDirection;
    if (message.selectedTrigger) this.selectedTrigger = message.selectedTrigger;
    if (message.beforeEvent || message.beforeEvent === 0) this.beforeEvent = message.beforeEvent;
    if (message.dependsOnUuid) this.dependsOnUuid = message.dependsOnUuid;
    if (message.date) this.date = message.date;
    if (message.time) this.time = message.time;

    return this;
  }
}
